//#region IMPORT
import Commons from '../../../Services/Common/Common';
import Global from '../../../Services/Common/Global';
import { showSnackbar } from '../../../Reducer/SnackbarReducer';
import dayjs from 'dayjs';
//#endregion

/**
 * 유해·위험 기계·기구 - 계측기 (HAZ_BASIC_03) 전용 로직
 * other 케이스에서 사용
 */

// 계측기 인쇄 함수 (PrintLogic1)
export const PrintLogic1 = async (
  documentData,
  dispatch,
  setLoading,
  rowData1,
  searchRef,
  userInfo
) => {
  setLoading(true);

  try {
    // 검색 연도 추출
    const currentYear = searchRef?.current?.currentYear;
    let year = '';
    if (currentYear) {
      year = currentYear.toString();
    } else {
      year = dayjs().year().toString();
    }

    const headerData = {
      YEAR: year,
    };

    const tableData = await Promise.all(
      rowData1.map(async (item) => {
        let instrumentImageBase64 = null;

        if (item.instrumentImageFilePath) {
          try {
            const fixedPath = Commons.EncodeUrl(item.instrumentImageFilePath);
            const imageUrl = Global.file.useUrl + 'files/' + fixedPath;

            const response = await fetch(imageUrl);
            if (response.ok) {
              const blob = await response.blob();
              const base64Image = await new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onloadend = () => resolve(reader.result);
                reader.onerror = reject;
                reader.readAsDataURL(blob);
              });

              if (base64Image && base64Image.startsWith('data:')) {
                instrumentImageBase64 = base64Image.replace(
                  /^data:image\/[a-z]+;base64,/,
                  ''
                );
              }
            }
          } catch (error) {
            instrumentImageBase64 = null;
          }
        }

        return {
          NO: item.no || '',
          INSTRUMENT_NAME: item.instrumentName || '',
          SERIAL_NO: item.serialNo || '',
          QTY: item.qty || '',
          SPEC: item.spec || '',
          DEPARTMENT: item.department || '',
          PERSON_IN_CHARGE: item.personInCharge || '',
          RECEIVING_DATE: item.receivingDate
            ? dayjs(item.receivingDate).format('YYYY-MM-DD')
            : '',
          MEASUREMENT_CYCLE: item.measurementCycle || '',
          CALIBRATION_DATE: item.calibrationDate
            ? dayjs(item.calibrationDate).format('YYYY-MM-DD')
            : '',
          NEXT_CALIBRATION_DATE: item.nextCalibrationDate
            ? dayjs(item.nextCalibrationDate).format('YYYY-MM-DD')
            : '',
          CALIBRATION_AGENCY: item.calibrationAgency || '',
          REMARK: item.remark || '',
          INSTRUMENT_IMAGE: instrumentImageBase64 || null,
        };
      })
    );

    const printData = {
      FileName: 'HAZ_BASIC_03',
      HeaderData: JSON.stringify(headerData),
      TableData: JSON.stringify(tableData),
    };

    const response = await Commons.Axios(
      'report',
      Global.base.useUrl + Global.urls.Reports.reports,
      printData
    );

    return response.data; // Blob 반환
  } catch (e) {
    console.error(e);
    dispatch(showSnackbar({ message: e.message, type: 'error' }));
    return null;
  } finally {
    setLoading(false);
  }
};

